// extracted by mini-css-extract-plugin
export default {"faqHelp":"JTAQ0ODpzc","faqHelpContainer":"VMOxM22ArZ"};